import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{style:(_vm.CSS_VARS),attrs:{"timeout":_vm.timeout,"color":"surface","bottom":"","left":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(VListItem,[_c(VListItemIcon,[_c(VIcon,{staticClass:"message-icon"},[_vm._v(_vm._s(_vm.icon))])],1),_c(VListItemContent,{class:_vm.itemContentClass},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]),_c(VListItemAction,[(_vm.showClose)?_c(VBtn,{attrs:{"color":"primary","text":""},on:{"click":_vm.cleanSnackbar}},[_vm._m(0)]):_vm._e()],1)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.$t('messages.close')))])
}]

export { render, staticRenderFns }